import { APP_BASE_HREF } from '@angular/common';
import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';

const assets = <const>{
  'assets/recruitee.png': require(`../../assets/recruitee.png`),
  'assets/open-in-new.png': require(`../../assets/open-in-new.png?preset=generic`),
  'assets/upgrade-icon.png': require(`../../assets/upgrade-icon.png`),
  'assets/checkmark.png': require(`../../assets/checkmark.png`),
  'assets/referrals.png': require(`../../assets/referrals.png`),
  'assets/referrals-de.png': require(`../../assets/referralshub-DE.png`),
  'assets/referrals-fr.png': require(`../../assets/referralshub-FR.png`),
  'assets/warning-icon.png': require(`../../assets/warning-icon.png`),
};

@Directive({
  standalone: true,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: `img`,
})
export class EmailImageAssetDirective {
  public baseHref = inject(APP_BASE_HREF, { optional: true });
  public renderer = inject(Renderer2);
  public elRef = inject(ElementRef);

  @Input() public src: keyof typeof assets;

  public ngOnChanges() {
    if (this.src.startsWith('http')) {
      this.elRef.nativeElement.src = this.src;
      return;
    }

    const hashedFilename = assets[this.src];

    this.elRef.nativeElement.src = this.baseHref
      ? `${this.baseHref}/${hashedFilename}`
      : hashedFilename;
  }
}
